import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="app-footer">
      <p>&copy; {new Date().getFullYear()} OptiPathway. All rights reserved. | <Link to="/contact">Contact</Link> | <Link to="/attribution">Attribution</Link></p>
    </footer>
  );
}

export default Footer;
